const description = {
    email: 'e-posta adresi',
    phone_number: 'telefon numarası',
    username: 'kullanıcı Adı',
    reminder: 'Hatırlatıcı',
    not_found: '404 Bulunamadı',
    agree_with_terms: 'Okudum ve anladım',
    agree_with_terms_modal: "Devam etmek için lütfen <link></link>'i kabul edin.",
    terms_of_use: 'Kullanım Koşulları',
    sign_in: 'Giriş Yap',
    privacy_policy: 'Gizlilik Politikası',
    create_account: 'Hesap Oluştur',
    switch_account: 'Hesabı değiştir',
    or: 'veya',
    and: 've',
    enter_passcode: 'Doğrulama kodu {{address}} {{target}} adresinize gönderildi',
    passcode_sent: 'Doğrulama kodu yeniden gönderildi',
    resend_after_seconds: 'Henüz almadınız mı? <span>{{seconds}}</span> saniye sonra tekrar gönderin',
    resend_passcode: 'Henüz almadınız mı? <a>Doğrulama kodunu tekrar gönderin</a>',
    create_account_id_exists: '{{value}} ile bir hesap zaten var. Giriş yapmaya devam edin.',
    link_account_id_exists: '{{type}} {{value}} olan hesap zaten var, bağlamak ister misiniz?',
    sign_in_id_does_not_exist: '{{value}} için hesap bulunamadı. Yeni bir tane oluşturulsun mu?',
    sign_in_id_does_not_exist_alert: '{{type}} {{value}} olan hesap mevcut değil.',
    create_account_id_exists_alert: '{{type}} {{value}} olan hesap başka bir hesaba bağlı. Lütfen başka bir {{type}} deneyin.',
    social_identity_exist: '{{type}} {{value}} başka bir hesaba bağlı. Lütfen başka bir {{type}} deneyin.',
    bind_account_title: 'Bağla veya hesap oluştur',
    social_create_account: 'Yeni bir hesap oluşturabilirsiniz.',
    social_link_email: 'Başka bir e-posta bağlayabilirsiniz',
    social_link_phone: 'Başka bir telefon bağlayabilirsiniz',
    social_link_email_or_phone: 'Başka bir e-posta veya telefon bağlayabilirsiniz',
    social_bind_with_existing: 'Kayıtlı bir ilgili hesap bulduk ve doğrudan bağlayabilirsiniz.',
    skip_social_linking: 'Mevcut hesabın bağlantısını atla?',
    reset_password: 'Parolanızı mı unuttunuz',
    reset_password_description: 'Hesabınızla ilişkili {{types, list(type: disjunction;)}} girin, şifrenizi sıfırlamanız için size doğrulama kodunu göndereceğiz.',
    new_password: 'Yeni Şifre',
    set_password: 'Şifreyi belirle',
    password_changed: 'Şifre değişti',
    no_account: 'Henüz hesap yok mu?',
    have_account: 'Zaten bir hesabınız var mıydı?',
    enter_password: 'Parolanı Gir',
    enter_password_for: '{{method}} {{value}} şifresiyle oturum açın',
    enter_username: 'Kullanıcı adını ayarla',
    enter_username_description: 'Kullanıcı adı, oturum açmak için bir alternatiftir. Kullanıcı adı yalnızca harf, sayı ve alt çizgi içermelidir.',
    enter_username_policy_description: 'Kullanıcı adı, oturum açmak için bir alternatiftir. {{requirements}}',
    link_email: 'E-postayı bağla',
    link_phone: 'Telefonu bağla',
    link_email_or_phone: 'E-posta veya telefon bağlantısı',
    link_email_description: 'Daha fazla güvenlik için lütfen e-postanızı hesapla ilişkilendirin.',
    link_phone_description: 'Daha fazla güvenlik için lütfen telefonunuzu hesaba bağlayın.',
    link_email_or_phone_description: 'Daha fazla güvenlik için lütfen e-postanızı veya telefonunuzu hesaba bağlayın.',
    continue_with_more_information: 'Daha fazla güvenlik için lütfen aşağıdaki hesap ayrıntılarını tamamlayın.',
    create_your_account: 'Hesabını oluştur',
    sign_in_to_your_account: 'Hesabına giriş yap',
    device_activation: 'Cihaz etkinleştirme',
    device_activation_description: 'Cihazınızda gösterilen kodu girin. Eşleştiğinden emin olun ve bu cihazda oturum açmaya devam edin.',
    device_activation_error_description: 'Cihazınızda görüntülenen kodu girin.',
    device_activation_success: 'Cihazınız bağlandı!',
    device_activation_success_description: 'Devam etmek için cihazınıza dönün.',
    no_region_code_found: 'Bölge kodu bulunamadı',
    verify_email: 'E-postanızın doğrulanması',
    verify_phone: 'Telefon numaranızın doğrulanması',
    password_requirements: 'Şifre {{items, list}}.',
    password_requirement: {
        length_one: 'en az {{count}} karakter gerektirir',
        length_two: 'en az {{count}} karakter gerektirir',
        length_few: 'en az {{count}} karakter gerektirir',
        length_many: 'en az {{count}} karakter gerektirir',
        length_other: 'en az {{count}} karakter gerektirir',
        character_types_one: 'en az {{count}} tane büyük harf, küçük harf, rakam ve sembol içermelidir',
        character_types_two: 'en az {{count}} tane büyük harf, küçük harf, rakam ve sembol içermelidir',
        character_types_few: 'en az {{count}} tane büyük harf, küçük harf, rakam ve sembol içermelidir',
        character_types_many: 'en az {{count}} tane büyük harf, küçük harf, rakam ve sembol içermelidir',
        character_types_other: 'en az {{count}} tane büyük harf, küçük harf, rakam ve sembol içermelidir',
    },
    username_requirements: 'Kullanıcı adı {{items, list}}.',
    username_requirement: {
        length: '{{min}} ile {{max}} karakter arasında olmalıdır',
        characters: 'yalnızca {{characters, list}} içerebilir',
    },
    username_character: {
        uppercase: 'büyük harfler',
        lowercase: 'küçük harfler',
        number: 'rakamlar',
        underscore: 'alt çizgiler',
    },
    use: 'Kullan',
    single_sign_on_email_form: 'Kurumsal e-posta adresinizi girin',
    single_sign_on_connectors_list: 'Şirketiniz, {{email}} e-posta hesabı için Tekli Oturum Açmayı (Single Sign-On) etkinleştirdi. Aşağıdaki SSO sağlayıcıları ile oturum açmaya devam edebilirsiniz.',
    single_sign_on_enabled: 'Bu hesapta Tekli Oturum Açma etkinleştirildi.',
    authorize_title: '{{name}} yetkilendir',
    request_permission: '{{name}} erişim izni istiyor:',
    grant_organization_access: 'Organizasyon erişimi ver:',
    authorize_personal_data_usage: 'Kişisel verilerinizin kullanımını yetkilendirin:',
    authorize_organization_access: 'Belirli organizasyonlara erişim yetkisi verin:',
    user_scopes: 'Kişisel kullanıcı verileri',
    organization_scopes: 'Organizasyon erişimi',
    authorize_agreement: `Erişim yetkisi vererek, {{name}}'nin <link></link> şartlarını kabul etmiş olursunuz.`,
    authorize_agreement_with_redirect: `Erişim yetkisi vererek, {{name}}'nin <link></link> şartlarını kabul etmiş olursunuz ve {{uri}} adresine yönlendirileceksiniz.`,
    not_you: 'Sen değil misin?',
    user_id: 'Kullanıcı ID: {{id}}',
    redirect_to: '{{name}} adresine yönlendirileceksiniz.',
    auto_agreement: 'Devam ederek <link></link> kabul etmiş oluyorsunuz.',
    identifier_sign_in_description: 'Oturum açmak için {{types, list(type: disjunction;)}} girin.',
    all_sign_in_options: 'Tüm oturum açma seçenekleri',
    identifier_register_description: 'Yeni bir hesap oluşturmak için {{types, list(type: disjunction;)}} girin.',
    all_account_creation_options: 'Tüm hesap oluşturma seçenekleri',
    password_expired: 'Şifrenizin süresi doldu ve giriş yapmadan önce sıfırlanması gerekiyor.',
    password_expiration_reset: 'Şifreyi sıfırla',
    back_to_sign_in: 'Girişe dön',
    support_email: 'Destek e-postası: <link></link>',
    support_website: 'Destek web sitesi: <link></link>',
    switch_account_title: 'Şu anda {{account}} olarak oturum açtınız',
    switch_account_description: 'Devam etmek için, mevcut hesaptan çıkış yapacak ve otomatik olarak yeni hesaba geçeceksiniz.',
    about_yourself: 'Kendinizden bahsedin',
    verify_identity: 'Kimliğinizi doğrulayın',
    choose_verification_method: 'Nasıl giriş yapmak istediğinizi seçin',
    verification_method: {
        passkey: 'Passkey',
        passkey_description: 'Cihazınız veya USB donanımıyla doğrulayın',
        password: 'Şifre',
        password_description: 'Şifrenizi girin',
        email_verification_code: 'E-posta doğrulama kodu',
        phone_verification_code: 'Telefon doğrulama kodu',
        verification_code_description: '{{target}} adresine gönder',
    },
};
export default Object.freeze(description);
